import React, { useEffect } from 'react';
import { Toggle, ToggleSize } from '../toggle/Toggle';
import { formConfigBase } from '@app/shared/constants/form-config-base';
import { FormProvider, useForm } from 'react-hook-form';
import styles from './discount-rate-override-toggles.module.scss';
import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import { setDiscountRateOverrideEnabled } from '@app/core/store/ui-values-slice';
import { updateProjectDraft } from '@app/core/store/project-slice';
import { useLocale } from '@app/core/hooks/useLocale';
import { useNavigate, useLocation } from 'react-router-dom';
import { RouteConstants } from '@app/modules/projects/RouteConstants';

const EnableDiscountRateOverride: React.FC = () => {
  const dispatch = useAppDispatch();
  const { l } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();
  const projectDraft = useAppSelector((state) => state.project.projectDraft);

  const discountRateOverrideEnabledState = useAppSelector(
    (state) => state.uiValues.discountRateOverrideEnabled
  );

  useEffect(() => {
    const persistedValue = projectDraft.pwermInput?.discountRateOverrideActive ?? false;
    if (persistedValue !== discountRateOverrideEnabledState) {
      dispatch(setDiscountRateOverrideEnabled(persistedValue));
    }
  }, [
    projectDraft.pwermInput?.discountRateOverrideActive,
    dispatch,
    discountRateOverrideEnabledState,
  ]);

  const formMethods = useForm({ ...formConfigBase });

  const handleToggleChange = (checked: boolean) => {
    dispatch(setDiscountRateOverrideEnabled(checked));
    dispatch(
      updateProjectDraft({
        project: {
          ...projectDraft,
          pwermInput: {
            ...projectDraft.pwermInput,
            discountRateOverrideActive: checked,
          },
        },
      })
    );

    if (!checked && location.pathname.includes(RouteConstants.DiscountRateOverride)) {
      navigate(`../${RouteConstants.CapmAssumptions}`);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <span>
        <Toggle
          name="discountRateOverrideEnabled"
          label={l('_EnableDiscountRateOverride')}
          toggleSize={ToggleSize.Medium}
          className={styles['discount-rate-override-toggle']}
          forceChecked={discountRateOverrideEnabledState}
          onChange={(e) => handleToggleChange(e.target.checked)}
          data-testid="enable-discount-rate-override-toggle"
        />
      </span>
    </FormProvider>
  );
};

export default EnableDiscountRateOverride;
